import CustomFieldsTabHeader from './header/CustomFieldsTabHeader';
import CustomFieldsTable from './table/CustomFieldsTable';

const CustomFieldsTab = () => {
  return (
    <>
      <CustomFieldsTabHeader />
      <CustomFieldsTable />
    </>
  );
};

export default CustomFieldsTab;
